import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getWeChatSettings = ({
  weChatAccountId
}: Partial<ChatsChannelBase>) => {
  if (!weChatAccountId) return null;

  const url = `weixin://dl/chat?${weChatAccountId}`;

  return {
    provider: ChatsChannelType.wechat,
    link: { url, options: { openCurrentPage: true } },
    title: 'WeChat',
    icon: getChatIcon(ChatsChannelType.wechat),
    withCaption: true,
    color: 'rgb(45, 193, 0)'
  } as ChatsChannelSetting;
};
